import { FETCH_ACTION_TYPES } from "_constants/FetchActionTypes";

export const LIBRARY_INITIAL_STATE = {
    pageTitle: "VSS Library",
    allCategories: [],
    categories: [],
    tags: { items: [] },
    hasTags: false,
    defaultExpanded: false,
    error: null
};

export const LIBRARY_ACTION_TYPES = {
    FILTER_TAG: "FILTER_TAG"
};

export const libraryDataReducer = (state, action) => {
    switch (action.type) {
        case FETCH_ACTION_TYPES.FETCH_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null
            };
        case FETCH_ACTION_TYPES.FETCH_ERROR:
            return {
                ...state,
                ...action.payload,
                allCategories: [],
                categories: [],
                tags: { items: [] },
                hasTags: false,
                defaultExpanded: false
            };
        case LIBRARY_ACTION_TYPES.FILTER_TAG:
            return {
                ...state,
                categories: action.payload.categories,
                tags: action.payload.tags
            };
        default:
            return state;
    }
};
